/**
 * Copyright (c) 2018, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 */
'use strict';

/**
 * oj-vb-content
 * @since  18.2.3
 *
 * A wrapper of the oj-module composite component used to extend the capabilities
 * for Visual Builder purposes.
 *
 * <code>
 * &lt;oj-vb-content config='[[moduleConfig]]' animation='[[moduleAnimation]]'>
 * &lt;/oj-vb-content>
 * </code>
 *
 */
define('vb/components/oj-vb-content/loader',[
  'ojs/ojcomposite',
  'text!./component.json',
  'ojs/ojmodule-element',
  'css!./styles.css',
], (Composite, metadataJson) => {
  const metadata = JSON.parse(metadataJson);

  const view = '<oj-module config="[[$props.config]]" animation="[[$props.animation]]"></oj-module>';

  Composite.register('oj-vb-content', {
    view,
    metadata,
  });
});

